import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import model from './model';
import Password from './Password';
import Email from './Email';
import Phone from './Phone';
import { withRouter } from 'src/helpers';
import Subscription from './Subscription';

class Security extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }
  savePw = (e) => {
    e.preventDefault();
    model.savePw();
  };
  cancel = (e) => {
    e.preventDefault();
  };

  render() {
    return (
      <div className={'mc-flex-20-col mc-grow'} style={{ overflow: 'auto' }}>
        <div className={'mc-main-content'} style={{ overflow: 'revert' }}>
          <Subscription />
        </div>
        <div className={'mc-main-content'} style={{ overflow: 'revert' }}>
          <Password />
        </div>
        <div className={'mc-main-content'} style={{ overflow: 'revert' }}>
          <Email />
        </div>
        <div className={'mc-main-content'} style={{ overflow: 'revert' }}>
          <Phone />
        </div>
      </div>
    );
  }
}

export default withRouter(Security);
